import { Box, Grid, Typography, makeStyles } from '@material-ui/core';

// hooks
// components
import { colors } from 'design-system';
import { useCoverageData } from 'src/components/screens/hooks';
import AssaMobile from './AssaMobile';
import { CardIndividualProps } from './CardIndividual';
import FreeMonthCard from './FreeMonthCard';

const useStyle = makeStyles(() => ({
  titleText: {
    fontSize: 19,
    fontWeight: 900,
  },
  infoText: {
    fontSize: 17,
    fontWeight: 700,
    textTransform: 'capitalize',
  },
  moneyText: {
    fontSize: 15,
    fontWeight: 400,
    color: colors.abbey,
  },
  titleSection: { paddingBottom: 7, marginBottom: 20 },
  logo: { marginRight: 11 },
}));

const IndividualBenefitsResume = ({
  coverageCatalogResumes,
  moneyType,
  packageOption,
  coverageCatalogs,
  unit,
  quotation,
  openDialog,
}: CardIndividualProps): JSX.Element => {
  const classes = useStyle();
  const { quotationEndorsement } = useCoverageData({
    coverageCatalogResumes,
    coverageCatalogs,
    unit,
    moneyType,
    packageOption,
  });

  return (
    <>
      <Grid container className={classes.titleSection}>
        <Box display="flex" sx={{ width: '100%' }}>
          <Box>
            <img
              src="svg/additional_benefits.svg"
              alt="additional_benefits_icon"
              className={classes.logo}
              data-testid="icon-image"
            />
          </Box>
          <Box flexGrow={1}>
            <Typography className={classes.titleText} data-testid="title-text">
              Beneficios de la póliza
            </Typography>
          </Box>
        </Box>
      </Grid>
      <AssaMobile data-testid="assa-mobile-logo" openDialog={openDialog} />
      {['RetencionBacCRC', 'RetencionBacUSD'].includes(quotation.productId) && (
        <FreeMonthCard data-testid="assa-card-logo" />
      )}
      <Grid container alignItems="center" justifyContent="space-between">
        <Box sx={{ marginTop: 12, display: 'flex', alignItems: 'center' }}>
          <Typography
            data-testid="benefit-name"
            style={{
              fontSize: 15,
              fontWeight: 500,
            }}
          >
            {quotationEndorsement.name}
          </Typography>
        </Box>
        <Box sx={{ marginTop: 12, display: 'flex', alignItems: 'center' }}>
          <Typography className={classes.moneyText}>
            {quotationEndorsement.value}
          </Typography>
        </Box>
      </Grid>
    </>
  );
};

export default IndividualBenefitsResume;
